var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "invoice-price-summary text-right row justify-end" },
    [
      _c(
        "table",
        [
          _vm.discount !== null
            ? _c("tr", [
                _c(
                  "td",
                  {
                    staticClass: "text-dark q-pr-md",
                    class: { "q-pb-md": !this.cashDiscount }
                  },
                  [_vm._v(_vm._s(_vm.discountText) + ":")]
                ),
                _c(
                  "td",
                  {
                    staticClass: "text-bold text-dark",
                    class: { "q-pb-md": !this.cashDiscount }
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm._f("inCurrency")(_vm.discountInCurrency)) +
                        "\n      "
                    )
                  ]
                )
              ])
            : _vm._e(),
          _vm.cashDiscount !== null
            ? _c("tr", [
                _c("td", { staticClass: "text-dark q-pr-md q-pb-md" }, [
                  _vm._v(_vm._s(_vm.$t("cash_discount")) + ":")
                ]),
                _c("td", {
                  staticClass: "text-bold text-dark q-pb-md",
                  domProps: { innerHTML: _vm._s(_vm.cashDiscountText) }
                })
              ])
            : _vm._e(),
          _c("tr", [
            _c("td", { staticClass: "text-dark q-pr-md" }, [
              _vm._v(_vm._s(_vm.$t("net")) + ":")
            ]),
            _c("td", { staticClass: "text-bold text-dark" }, [
              _vm._v(_vm._s(_vm._f("inCurrency")(_vm.net)))
            ])
          ]),
          _vm._l(_vm.salesTaxRates, function(rate, index) {
            return _c("tr", { key: index }, [
              _c("td", { staticClass: "text-dark q-pr-md" }, [
                _vm._v(
                  _vm._s(_vm.$t("sales_tax")) + " " + _vm._s(rate.tax) + "%:"
                )
              ]),
              _c("td", { staticClass: "text-bold text-dark" }, [
                _vm._v(_vm._s(_vm._f("inCurrency")(rate.value)))
              ])
            ])
          }),
          _c("tr", [
            _c("td", { staticClass: "text-dark q-pr-md" }, [
              _vm._v(_vm._s(_vm.$t("gross")) + ":")
            ]),
            _c("td", { staticClass: "text-bold text-dark" }, [
              _vm._v(_vm._s(_vm._f("inCurrency")(_vm.gross)))
            ])
          ])
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }